// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.singleEventCardContainer_No9kL {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	background-color: transparent;
	width: 100%;
	gap: 20px;
	background: var(--f5-background);
	border-top: 1px solid var(--border-color);
	cursor: pointer;
}

.lastSingleEventCardContainer_B3VCG {
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	background-color: transparent;
	width: 100%;
	gap: 20px;
	border-bottom: 1px solid var(--border-color);
	border-top: 1px solid var(--border-color);
	background: var(--f5-background);
	cursor: pointer;
}

.dateContainer_UYpw9 {
	padding: 3px;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 15px;
	color: #333;
	font-weight: 600;
	width: 110px !important;
	max-width: 110px !important;
	min-width: 110px !important;
}
.eventPopup_NNOLY {
	position: absolute;
	top: 97px;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 8px;
	z-index: 700000;
}
.itemContainer_lhR8Z {
	display: flex;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	align-items: flex-start;
	position: relative;
	width: 100%;
	justify-content: flex-start;
	padding: 8px;
	border-radius: 5px;
	gap: 20px;
	transition: background 0.01s ease-in-out;
	&:hover {
		background: var(--_16c0982e-background);
	}
}
.day_UulMG {
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--_3c3a3a-color);
	transition: background 0.01s ease-in-out;
	&:hover {
		background: var(--_16c0982e-background);
	}
}

.monthDayName_aA1Rq {
	font-size: 12px;
	color: var(--text-color-secondary);
	width: 80px;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	flex-direction: row;
}

.timeContainer_maDTm {
	display: flex;
	align-items: center;
	min-width: 160px;
}

.dot_USi_x {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: var(--_16c09821-background);
	margin-right: 15px;
	margin-bottom: 2px;
}
.eventsContainer_PzLwY {
	padding: 10px;
	background: var(--white-color);
	display: flex;
	width: 100%;
	align-items: flex-start;
	flex-direction: column;
	gap: 5px;
	justify-content: flex-start;
}
.hour_Dp0qV {
	font-size: 14px;
	font-weight: 600;
	color: var(--text-color-secondary);
}

.eventDetails_l_4an {
	flex-grow: 1;
	padding-left: 10px;
}

.title_ET65r {
	font-size: 14px;
	font-weight: bold;
	color: var(--_3c3a3a-color);
	margin-bottom: 2px;
}

.description_Wcqcw {
	font-size: 12px;
	color: var(--text-color-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/SingleEventCard.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,6BAA6B;CAC7B,WAAW;CACX,SAAS;CACT,gCAAgC;CAChC,yCAAyC;CACzC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,6BAA6B;CAC7B,WAAW;CACX,SAAS;CACT,4CAA4C;CAC5C,yCAAyC;CACzC,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,uBAAuB;CACvB,2BAA2B;CAC3B,2BAA2B;AAC5B;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,gCAAgC;CAChC,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,aAAa;CACb,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;CACX,2BAA2B;CAC3B,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,wCAAwC;CACxC;EACC,uCAAuC;CACxC;AACD;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,yBAAiB;SAAjB,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,2BAA2B;CAC3B,wCAAwC;CACxC;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,WAAW;CACX,aAAa;CACb,uBAAuB;CACvB,2BAA2B;CAC3B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,6CAA6C;CAC7C,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,8BAA8B;CAC9B,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,sBAAsB;CACtB,QAAQ;CACR,2BAA2B;AAC5B;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC","sourcesContent":[".singleEventCardContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\twidth: 100%;\n\tgap: 20px;\n\tbackground: var(--f5-background);\n\tborder-top: 1px solid var(--border-color);\n\tcursor: pointer;\n}\n\n.lastSingleEventCardContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: transparent;\n\twidth: 100%;\n\tgap: 20px;\n\tborder-bottom: 1px solid var(--border-color);\n\tborder-top: 1px solid var(--border-color);\n\tbackground: var(--f5-background);\n\tcursor: pointer;\n}\n\n.dateContainer {\n\tpadding: 3px;\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tgap: 15px;\n\tcolor: #333;\n\tfont-weight: 600;\n\twidth: 110px !important;\n\tmax-width: 110px !important;\n\tmin-width: 110px !important;\n}\n.eventPopup {\n\tposition: absolute;\n\ttop: 97px;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tborder-radius: 8px;\n\tz-index: 700000;\n}\n.itemContainer {\n\tdisplay: flex;\n\tcursor: pointer;\n\tuser-select: none;\n\talign-items: flex-start;\n\tposition: relative;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\tpadding: 8px;\n\tborder-radius: 5px;\n\tgap: 20px;\n\ttransition: background 0.01s ease-in-out;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n.day {\n\tfont-size: 18px;\n\tfont-weight: bold;\n\tcursor: pointer;\n\tuser-select: none;\n\twidth: 30px;\n\theight: 30px;\n\tmin-width: 30px;\n\tmin-height: 30px;\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: var(--_3c3a3a-color);\n\ttransition: background 0.01s ease-in-out;\n\t&:hover {\n\t\tbackground: var(--_16c0982e-background);\n\t}\n}\n\n.monthDayName {\n\tfont-size: 12px;\n\tcolor: var(--text-color-secondary);\n\twidth: 80px;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n}\n\n.timeContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-width: 160px;\n}\n\n.dot {\n\twidth: 12px;\n\theight: 12px;\n\tborder-radius: 50%;\n\tbackground-color: var(--_16c09821-background);\n\tmargin-right: 15px;\n\tmargin-bottom: 2px;\n}\n.eventsContainer {\n\tpadding: 10px;\n\tbackground: var(--white-color);\n\tdisplay: flex;\n\twidth: 100%;\n\talign-items: flex-start;\n\tflex-direction: column;\n\tgap: 5px;\n\tjustify-content: flex-start;\n}\n.hour {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tcolor: var(--text-color-secondary);\n}\n\n.eventDetails {\n\tflex-grow: 1;\n\tpadding-left: 10px;\n}\n\n.title {\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tcolor: var(--_3c3a3a-color);\n\tmargin-bottom: 2px;\n}\n\n.description {\n\tfont-size: 12px;\n\tcolor: var(--text-color-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleEventCardContainer": `singleEventCardContainer_No9kL`,
	"lastSingleEventCardContainer": `lastSingleEventCardContainer_B3VCG`,
	"dateContainer": `dateContainer_UYpw9`,
	"eventPopup": `eventPopup_NNOLY`,
	"itemContainer": `itemContainer_lhR8Z`,
	"day": `day_UulMG`,
	"monthDayName": `monthDayName_aA1Rq`,
	"timeContainer": `timeContainer_maDTm`,
	"dot": `dot_USi_x`,
	"eventsContainer": `eventsContainer_PzLwY`,
	"hour": `hour_Dp0qV`,
	"eventDetails": `eventDetails_l_4an`,
	"title": `title_ET65r`,
	"description": `description_Wcqcw`
};
export default ___CSS_LOADER_EXPORT___;
